import React from 'react';
import ShoppingListContainer from './ShoppingList.container';

// Bridge component to match Wasp's expected named export
export function ShoppingListPage() {
  return <ShoppingListContainer />;
}

